/**
 * User: n.gorte
 * Date: 28.06.2022
 * Time: 14:19
 */
/**
 * Created by Carsten Bühler
 * User: CBuehler on 05.09.2016
 * Copyright: xdot GmbH 2015
 */
'use strict';

import L from 'external/leaflet';
import React from 'external/react';
import '../css/search-plugin.scss';
import { SearchBox } from './SearchPlugin/SearchBox';

export default class CoordinatesSearchPlugin {

    constructor(props, config){
        this.config = config;
        this.props = props;

        this.onInputChange = this.onInputChange.bind(this);
        this.search = this.search.bind(this);
        this.setPlaceMarker = this.setPlaceMarker.bind(this);
        this.onHide = this.onHide.bind(this);
    }

    init(map, o, reEvaluate){
        this._reEvaluate = reEvaluate;
        this._map = map;
        this._options = o;

        this.placeMarker = L.marker().bindPopup();

        this.searchControl = new SearchBox({
            title: 'Koordinatensuche',
            placeholder: 'Lat, Lon Z.B. (48.1, 7.5)',
            icon: 'icon icon-fliwas-search-crosshair'
        });
        map.addControl(this.searchControl);
        this.searchControl.onInput('input', this.onInputChange);
        this.searchControl.onInput('keydown', this.search);
        this.searchControl.onHide(this.onHide);
    }

    update(map, o){
        this._options = o;
    }

    remove(){
        this._map.off();
        this.placeMarker && this.placeMarker.remove();
        if (this.searchControl) {
            this.searchControl.remove();
        }
        this._map = null;
    }

    onInputChange(e){
        let values = e.target.value;
        values = values.split(',');
        this.lat = values[0] !== '' && Number.parseFloat(values[0]);
        this.lng = values[1] !== '' && Number.parseFloat(values[1]);
    }

    onHide(){
        this.placeMarker && this.placeMarker.remove();
    }

    search(e){
        if (e.key === 'Enter') {
            if (Number.isFinite(this.lat) && Number.isFinite(this.lng)) {
                this.latLng = [this.lat, this.lng];
                this.setPlaceMarker();
                this._map.setView(this.latLng, 16);
            } else {
                alert('Ungültige Koordinateneingabe.');
            }
        }
    }

    setPlaceMarker(){
        this.placeMarker.setLatLng(this.latLng);
        if (!this._map.hasLayer(this.placeMarker)) {
            this.placeMarker.addTo(this._map);
        }

        this.placeMarker.setPopupContent(`Lat, Lon: ${this.latLng.toString()}`);
        this.placeMarker.openPopup();
    }

}



// WEBPACK FOOTER //
// ./js/plugins/CoordinatesSearchPlugin.js